import React from 'react';
import { Icon } from '../../';
//import { ReactComponent as Spinner} from '../../../../assets/img/icons/graph-loading-spinner.svg';

const _GraphLoadingSpinner = ({ type, text }, ref) => {
  return (
    <div className="loading-graph">
      <Icon name={`${type}_graph_spinner`} className="loading-graph-spinner" />
      <div className="loading-graph-text">{text || 'Drawing the graph...'}</div>
    </div>
  );
};

export const GraphLoadingSpinner = _GraphLoadingSpinner;
